import React, { useEffect } from "react";
import articlesStore from "../../store/articles/ArticlesStore";
import { useParams } from "react-router-dom";
import CircularProgress from "@material-ui/core/CircularProgress";
import { getArticles } from "../../store/articles/ArticlesApi";
import { Button, Typography } from "@material-ui/core";
import { ToastContainer } from "react-toastify";
import ArticleTagEditor from "./../ArticlesMenu/ArticleTagEditor";
import { getSupergroupsFromStores } from "../../store/articles/ArticlesHelpers";

function SupergroupArticles() {
  const merchantId = Number.parseInt(useParams().merchantId);
  const [supergroups, setSupergroups] = React.useState(null);
  const [selectedSupergroup, setSelectedSupergroup] = React.useState(null);

  const onMenuUpdated = () => {
    if (articlesStore.supergroups != null) {
      setSupergroups(getSupergroupsFromStores());
    } else {
      setSupergroups(null);
    }
  };

  useEffect(() => {
    articlesStore.on(articlesStore.events.MENU_UPDATED, onMenuUpdated);
    return () => {
      articlesStore.removeListener(articlesStore.events.MENU_UPDATED, onMenuUpdated);
    };
  }, []);

  useEffect(() => {
    if (merchantId !== articlesStore.merchantId) {
      if (supergroups != null) {
        setSupergroups(null);
      }
      getArticles(merchantId);
    } else if (supergroups == null && articlesStore.supergroups != null) {
      onMenuUpdated();
    }
  }, []);

  if (!supergroups) {
    return (
      <div align="center">
        <CircularProgress color="primary" />
      </div>
    );
  }

  return (
    <div>
      <Typography></Typography>
      <div style={{ display: "flex", flexFlow: "wrap" }}>
        <Button
          key={null}
          style={{ margin: "8px 16px" }}
          variant={null === selectedSupergroup ? "contained" : "outlined"}
          color={"primary"}
          onClick={() => {
            setSelectedSupergroup(null);
          }}
        >
          No supergroup
        </Button>

        {supergroups.map((supergroup) => (
          <Button
            key={supergroup.id}
            style={{ margin: "8px 16px" }}
            variant={supergroup === selectedSupergroup ? "contained" : "outlined"}
            color={"primary"}
            onClick={() => {
              setSelectedSupergroup(supergroup);
            }}
          >
            {supergroup.tag}
          </Button>
        ))}
      </div>
      <ArticleTagEditor selectedTag={selectedSupergroup?.tag} type={"supergroup_tags"} />
      <ToastContainer
        position="bottom-right"
        autoClose={2000}
        hideProgressBar
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
}

export default SupergroupArticles;
